<template>
  <v-dialog
    v-model="show"
    persistent
    max-width="350"
  >
    <v-card>
      <v-card-title class="dialog">
        <v-icon
          color="error"
          x-large
          class=" mb-4 mt-2"
        >mdi-alert-octagon</v-icon><br>
        <b>{{ this.dialogAlert }}</b>
      </v-card-title>
      <v-card-text class="dialog-detail">
        {{ this.dialogAlertDetail }}
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          v-if="showCancelBtn"
          depressed
          class="mb-2"
          @click="show = false"
        >
          {{ $t('cancel') }}
        </v-btn>
        <v-btn
          color="error"
          depressed
          class="mb-2"
          @click.stop="confirm"
        >
          {{ $t('confirm') }}
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: Boolean,
    showCancelBtn: Boolean,
    dialogAlert: String,
    dialogAlertDetail: String,
  },
  methods: {
    confirm() {
      this.show = false;
      this.$emit('error-child-method');
    },
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>

<style scoped lang="scss">
  @import '@/scss/modules/m-dialog.scss';
</style>
